import {stringify} from 'qs'
import {format} from 'utils'
import request from 'crm/utils/request'
import api from './api'

export async function groups() {
    return request(api.groups.url)
}

export async function taskDetail(payload) {
    return request(format(api.taskDetail.url, {id: payload.taskId}))
}

export async function list(payload) {
    return request(
        `${format(api.list.url, {id: payload.taskId})}${stringify(payload.params, {
            addQueryPrefix: true,
        })}`,
    )
}

export async function storeFeedbackList(payload) {
    return request(
        `${format(api.storeFeedbackList.url, {store_id: payload.storeId})}?${stringify({
            type: payload.type,
            taskId: payload.taskId,
        })}`,
    )
}

export async function exportDetailData(payload) {
    return request(
        `${format(api.exportDetailData.url, {task_id: payload.taskId})}?${stringify(payload)}`,
        null,
        {
            returnResponse: true,
        },
    )
}
